import React, { Component } from "react";
import PopupForm from "./PopupForm";

class Rodape extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopup: false,
      formData: {
        nome: "",
        telefone: "",
        formValido: true,
        enviado: false,
        msg_enviado: "",
      },
    };
  }

  abrirPopup = () => {
    this.setState({ openPopup: true });
  };

  fecharPopup = () => {
    this.setState(prevState => ({
      ...prevState,
      openPopup: false,
    }));
  };

  enviarFormulario = async (formData) => {
    const { nome, telefone } = formData;

    if (!nome || !telefone) {
      // Validação simples
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Por favor, preencha todos os campos.",
        },
      }));
      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);
      return;
    }

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        enviado: true,
        msg_enviado: "Enviando mensagem...",
      },
    }));

    // Monta a mensagem em HTML
    const mensagem = `Nome: ${nome}<br>Telefone: ${telefone}`;

    // Lista de destinatários (substitua pelo email do vendedor)
    const destinatarios = ["ragamotorsudi@gmail.com"];

    try {
      const fetchPromises = destinatarios.map(email => {
        return fetch(
          "https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              remetente: "Contato Site Raga Motors <ragamotorsudi@gmail.com>",
              assunto: "Contato pelo site",
              destinatarios: email,
              corpo: mensagem,
              corpoHtml: mensagem,
            }),
          }
        );
      });

      await Promise.all(fetchPromises);

      // Mensagem de sucesso
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Mensagem enviada com sucesso!",
          nome: "",
          telefone: "",
        },
      }));

      // Fecha a mensagem após alguns segundos
      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);

    } catch (error) {
      // Mensagem de erro
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Erro ao enviar mensagem. Tente novamente mais tarde.",
        },
      }));

      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);

      console.error("Erro no envio do formulário:", error);
    }
  };


  render() {
    const { revenda } = this.props;
    const { openPopup, formData } = this.state;

    return (
      <>
        <footer className="footer-3 footer-topbar light page-section-pt">
          <div className="container">
            <div className="row top">
              <div className="col-lg-3 col-md-12">
                <img
                  className="img-fluid"
                  id="logo_footer_dark"
                  src="images/logo.png"
                  alt=""
                />
              </div>

              <div className="col-lg-4 col-md-12">
                {/* Whatsapp */}
                {/* <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">  */}
                <a className='whatsappFlutuante' href={'https://api.whatsapp.com/send?text=Olá,vi um anúncio em seu site e gostaria de saber mais sobre o veículo?&phone=55' + retiraMascara(this.props.revenda.petelefone2, "link")} target='_blank' >
                  <i className="fa fa-whatsapp"></i>
                </a>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="social text-lg-right text-center">
                  <ul>
                    <li>
                      <a href={this.props.revenda.facebook_link} target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook-square"></i></a>
                    </li>
                    <li>
                      <a href={this.props.revenda.instagram_link} target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram" target="_blank"></i></a>
                    </li>
                    {/*<li>
                    <a target="_blank" href={ 'https://api.whatsapp.com/send?text=Olá, vi um anúncio em seu site e gostaria de saber mais sobre o veículo ?&phone=55'+retiraMascara(this.props.revenda.petelefone2, "link") }><i className="fa fa-whatsapp"></i></a>
                  </li>*/}
                    {/* <li>
                    <a target="_blank" href={ 'https://api.whatsapp.com/send?text=Olá, vi um anúncio em seu site e gostaria de saber mais sobre o veículo ?&phone=55'+retiraMascara(this.props.revenda.petelefone3, "link") }><i className="fa fa-whatsapp"></i></a>
                  </li> */}
                    <li>
                      <a target="_blank" href={this.props.revenda.mapa_link} className="wow slideInLeft" rel="noopener noreferrer" ><i className="fa fa-map-marker"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
<hr class="espacamento"></hr>
            {/* Sobre nós */}
            <div className="row" style={{ justifyContent: "center", textAlign: "center", marginBottom: "20px" }}>
              <div className="col-lg-5 col-md-12">
                <div className="about-content">
                  <h6 className="text-sobrenos">Sobre nós</h6>
                  <p className="text-sobrenos-info">
                    A Raga Motors é uma loja especializada na venda de veículos, oferecendo uma ampla variedade de modelos novos e seminovos. Comprometida com a qualidade e a satisfação dos clientes, a Raga Motors se destaca pelo atendimento personalizado e condições atrativas de pagamento, proporcionando uma experiência de compra segura e confiável.
                  </p>
                </div>
              </div>

              {/* Informações da loja */}
              <div className="col-lg-7 col-md-12">
                <h6 className="text-sobrenos">Informações da loja</h6>
                <ul className="text-sobrenos-info">
                  <li>{revenda.peendereco_fiscal} - {revenda.peendereco_fiscal_numero} - {revenda.pebairro_fiscal} - {revenda.pecidade} - {revenda.peuf}</li>
                  <li>
                    <i className="fa fa-envelope-o" style={{ marginRight: "10px" }}></i>
                    <a href={"mailto:" + revenda.peemail}>{revenda.peemail}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

        {/* Popup Form */}
        <PopupForm
          open={openPopup}
          onClose={this.fecharPopup}
          onSubmit={this.enviarFormulario}
          state={formData}
        />
      </>
    );
  }
}

function retiraMascara(value, type = "texto") {
  var numero = '';
  if (value !== undefined) {
    numero = value.replace('_', '');
    if (type === "link") {
      numero = numero.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');
    }
  }
  return numero;
}


export default Rodape;
